<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Import PI Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/lc/import-pi-create')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create PI
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getLcImportPiList"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.pi_no="{ item }">
                    {{ item.pi_no }}
                  </template>

                  <template v-slot:item.code="{ item }">
                    {{ item.code }}
                  </template>

                  <template v-slot:item.pi_date="{ item }">
                    {{ (item.pi_date) }}
                  </template>

                  <template v-slot:item.supplier="{ item }">
                    {{ item.supplier?.supplier_name || "N/A" }}
                  </template>

                  <template v-slot:item.total_amount="{ item }">
                    {{ $numberFormat(item.total_amount) }}
                  </template>

                  <template v-slot:item.approval_status="{ item }">
                    <v-chip
                      :color="getApprovalStatusColor(item.approval_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.approval_status || "Approved" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status == 1 ? 'success' : 'warning'"
                      size="small"
                    >
                      {{ item.status == 1 ? "Posted" : "Draft" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="primary"
                      @click="editItem(item.id)"
                    ></v-btn>
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewItem(item.id)"
                    ></v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";

export default {
  data: () => ({
    panel: [0],
    panel1: [0],
    loading: false,
    search: "",
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "PI No", key: "pi_no", align: "left", sortable: true },
      { title: "PI Code", key: "code", align: "left", sortable: true },
      { title: "PI Date", key: "pi_date", align: "left", sortable: true },
      { title: "Supplier", key: "supplier", align: "left", sortable: false },
      { title: "Total Amount", key: "total_amount", align: "right", sortable: true },
      { title: "Approval Status", align: "center", key: "approval_status", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false, width: "10%" },
    ],
  }),
  setup() {
    const { proxy } = getCurrentInstance();
    const { handleSubmit } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const store = useStore();
    const router = useRouter();

    const getLcImportPiList = computed(() => {
      return store.getters.getLcImportPiList || [];
    });

    onMounted(() => {
      loadData();
    });

    const loadData = async () => {
      try {
        await store.dispatch("getLcImportPiList");
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load PI records");
      }
    };

    const submit = handleSubmit(async (values) => {
      // Filter/search logic can be added here if needed
      await loadData();
    });

    const editItem = (id) => {
      router.push({ path: `/lc/import-pi-create/${id}` });
    };

    const viewItem = (id) => {
      router.push({ path: `/lc/import-pi-view/${id}` });
    };

    const exportToCSV = () => {
      const items = getLcImportPiList.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const data = [
        ["#SL", "PI No", "PI Code", "PI Date", "Supplier", "Total Amount", "Approval Status", "Status"],
      ];

      items.forEach((item, index) => {
        data.push([
          index + 1,
          item.pi_no || "",
          item.code || "",
          formatDateView(item.pi_date),
          item.supplier?.supplier_name || "N/A",
          item.total_amount ?? 0,
          item.approval_status || "Approved",
          item.status == 1 ? "Posted" : "Draft",
        ]);
      });

      if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
        proxy.$exportTableToCSV(
          data,
          "lc_import_pi_records_" + proxy.$fileDate()
        );
      } else {
        toast.error("CSV export is not configured");
      }
    };

    const exportToExcel = () => {
      const items = getLcImportPiList.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const data = [
        ["#SL", "PI No", "PI Code", "PI Date", "Supplier", "Total Amount", "Approval Status", "Status"],
      ];

      items.forEach((item, index) => {
        data.push([
          index + 1,
          item.pi_no || "",
          item.code || "",
          formatDateView(item.pi_date),
          item.supplier?.supplier_name || "N/A",
          item.total_amount ?? 0,
          item.approval_status || "Approved",
          item.status == 1 ? "Posted" : "Draft",
        ]);
      });

      if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
        proxy.$exportTableToExcel(
          data,
          "lc_import_pi_records_" + proxy.$fileDate()
        );
      } else {
        toast.error("Excel export is not configured");
      }
    };

    const exportToPDF = () => {
      const items = getLcImportPiList.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const columns = [
        "#SL",
        "PI No",
        "PI Code",
        "PI Date",
        "Supplier",
        "Total Amount",
        "Approval Status",
        "Status",
      ];

      const rows = items.map((item, index) => [
        index + 1,
        item.pi_no || "",
        item.code || "",
        formatDateView(item.pi_date),
        item.supplier?.supplier_name || "N/A",
        item.total_amount ?? 0,
        item.approval_status || "Approved",
        item.status == 1 ? "Posted" : "Draft",
      ]);

      if (proxy?.$exportTableToPDF && proxy?.$fileDate) {
        proxy.$exportTableToPDF(
          columns,
          rows,
          "LC Import PI Records",
          "lc_import_pi_records_" + proxy.$fileDate()
        );
      } else {
        toast.error("PDF export is not configured");
      }
    };

    const getApprovalStatusColor = (status) => {
      const colors = {
        Pending: "warning",
        Approved: "success",
        Cancelled: "error",
      };
      return colors[status] || "success";
    };

    return {
      from_date,
      to_date,
      getLcImportPiList,
      submit,
      editItem,
      viewItem,
      exportToCSV,
      exportToExcel,
      exportToPDF,
      loadData,
      getApprovalStatusColor,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
  },
};
</script>

